import { render, staticRenderFns } from "./DashboardListRow.vue?vue&type=template&id=28561a36&scoped=true&"
import script from "./DashboardListRow.vue?vue&type=script&lang=js&"
export * from "./DashboardListRow.vue?vue&type=script&lang=js&"
import style0 from "./DashboardListRow.vue?vue&type=style&index=0&id=28561a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28561a36",
  null
  
)

export default component.exports